import React from 'react'
import { addStoreLocaleByCookie } from 'lib/storeLocale/client'
import type { ConnectorProps as AppProps } from '../connectors/App'
import AppConnector from '../connectors/App'
import Modal from './Modal'

type Props = AppProps & {
  dataStyle: string
  modalName: string
}

const Component = (props: Props): React.ReactElement<React.ComponentProps<any>, any> => {
  const {
    userRole,
    isAuthenticated,
    dataStyle,
    addMessage,
    openModal,
    closeModal,
    modalName,
  } = props

  const handleClick = () => {
    if (!isAuthenticated) {
      openModal('login')
    } else if (userRole === 'collector') {
      openModal(modalName)
    } else {
      const location = addStoreLocaleByCookie('/studio')
      window.location = location
    }
  }

  const getButtonTitle = () => {
    if (!isAuthenticated) {
      return 'Get Started'
    } else if (userRole === 'collector') {
      return 'Create Artist Account'
    } else {
      return 'Upload Artwork'
    }
  }

  return (
    <>
      <button type='button' data-type='black-button' data-style={dataStyle} onClick={handleClick}>
        {getButtonTitle()}
      </button>
      <Modal closeModal={closeModal} addMessage={addMessage} modalName={modalName} />
    </>
  )
}

export default AppConnector(Component)
